import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=a07b51b4"
import script from "./appFooter.vue?vue&type=script&lang=js"
export * from "./appFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports